/** Mirrors domain.QuoteEditLock, which has no generated TS type. */
export type QuoteEditLock = {
  quoteId: string;
  editorId: string;
  editorName: string;
  /** RFC 3339 instant after which the lease no longer blocks other editors. */
  expiresAt: string;
};

export enum QuoteEditLockStatus {
  Inactive = 'inactive',
  Acquiring = 'acquiring',
  Held = 'held',
  Blocked = 'blocked',
}

/** Payload of the ON_QUOTE_EDIT_LOCK_CHANGED websocket event; `editor` is null once the lock is released. */
export type QuoteEditLockChangedEvent = {
  quoteId: string;
  editor: { id: string; name: string } | null;
  expiresAt?: string;
};
